// @ts-nocheck
import React from 'react';

const Skeleton = ({ width = '100%', height = 10, radius = 6, className = '', style }) => (
  <span
    className={['mov-skeleton inline-block align-middle', className].join(' ')}
    style={{
      display: 'block',
      width,
      height,
      borderRadius: radius,
      background: 'linear-gradient(90deg, #ece8de 0%, #f4f1e7 50%, #ece8de 100%)',
      backgroundSize: '200% 100%',
      animation: 'mov-shimmer 1.4s linear infinite',
      ...style,
    }}
  />
);

export default Skeleton;
